import React, { FC } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

interface CommonLoaderProps {
  loadingMessage?: string;
}

const CommonLoader: FC<CommonLoaderProps> = ({ loadingMessage }) => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: 320,
        p: 3
      }}
    >
      <CircularProgress
        size={44}
        thickness={4}
        sx={{ color: "primary.main" }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 2, fontWeight: 500 }}
      >
        {loadingMessage ?? t("common-loader-loading", "Loading...")}
      </Typography>
    </Box>
  );
};

export default CommonLoader;
